import { useContext } from "react";
import { AppContext } from "../App";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";

export const Intro = () => {
	const nextPage = "damageGlass";
	const previousPage = "bookingForm";

	return (
		<>
			<Header />
			<Content />
			<Footer nextPage={nextPage} previousPage={previousPage} />
		</>
	);
};

const Content = () => {
	const { data, openPopUpClientEdit, isTransitioning } =
		useContext(AppContext);

	return (
		<div
			className={
				"content kensei_03" + (isTransitioning ? " fade-in" : "")
			}
		>
			<div className="content_intro">
				<p className="intro_info">
					<strong>{data.name}</strong>, vamos a completar tu cita para
					un servicio de lunas en el{" "}
					<strong>Taller {data.centerName}</strong>
				</p>
				<p className="intro_contact">
					Por favor, Confirma que tus datos de contacto son correctos.
				</p>
				<div className="intro_data">
					<div className="info_client">
						<h2>
							<span>Datos cliente</span>
							<button onPointerDown={openPopUpClientEdit}>
								<img
									className="client_edit"
									src="resources/icons/edit.svg"
									alt="Editar datos del cliente"
								/>
							</button>
						</h2>
						<ul>
							<li>
								<strong>Nombre:</strong> {data.name}
							</li>
							<li>
								<strong>Teléfono:</strong> {data.phone}
							</li>
							<li>
								<strong>Email:</strong> {data.email}
							</li>
						</ul>
					</div>
					<div className="info_vehicle">
						<h2>Datos del vehículo</h2>
						<ul>
							<li>
								<strong>Marca:</strong> {data.brand}
							</li>
							<li>
								<strong>Matrícula:</strong> {data.plate}
							</li>
							<li>
								<strong>Modelo:</strong> {data.model}
							</li>
							<li>
								<strong>Bastidor:</strong> {data.chasis}
							</li>
						</ul>
					</div>
				</div>
				<p className="intro_info2">
					Para agilizar el servicio y la disponibilidad de recambios,
					a continuación te vamos a solicitar información sobre el
					estado de la luna
				</p>
			</div>
		</div>
	);
};
